import Rectangle from "./Geometry/Rectangle";
import Circle from "./Geometry/Circle";
import NullShape from "./Geometry/NullShape";
import RightAngledTriangle from "./Geometry/RightAngledTriangle";
import RightAngledTriangleMirrored from "./Geometry/RightAngledTriangleMirrored";
import Ellipse from "./Geometry/Ellipse";
import Egg from "./Geometry/Egg";
import RoundedRectangle from "./Geometry/RoundedRectangle";
import IsoscelesTriangle from "./Geometry/IsoscelesTriangle";
import HalfCircle from "./Geometry/HalfCircle";
import QuarterCircle from "./Geometry/QuarterCircle";
import Hexagon from "./Geometry/Hexagon";
import Octagon from "./Geometry/Octagon";
import Polygon from "./Geometry/Polygon";
import Arrow from "./Geometry/Arrow";
import Star from "./Geometry/Star";
import SlopedRectangle from "./Geometry/SlopedRectangle";
import SlopedRightRectangle from "./Geometry/SlopedRightRectangle";
import ArchedRectangle from "./Geometry/ArchedRectangle";
import Heart from "./Geometry/Heart";
import Text from "./Geometry/Text";
import Trapezoid from "./Geometry/Trapezoid";
import FlatOval from "./Geometry/FlatOval";
import Kite from "./Geometry/Kite";
import Barrel from "./Geometry/Barrel";
import Jewel from "./Geometry/Jewel";
import Droplet from "./Geometry/Droplet";
import Parallelogram from "./Geometry/Parallelogram";
import SlopedRectangleFlipHorizontal from "./Geometry/SlopedRectangleFlipHorizontal";
import SlopedRightRectangleFlipVertical from "./Geometry/SlopedRightRectangleFlipVertical";
import ParallelogramFlipHorizontal from "./Geometry/ParallelogramFlipHorizontal";

export default class ShapeFactory {
	constructor() {
		this.shapes = {
			[ Rectangle.NAME ]: Rectangle,
			[ Circle.NAME ]: Circle,
			[ RightAngledTriangle.NAME ]: RightAngledTriangle,
			[ RightAngledTriangleMirrored.NAME ]: RightAngledTriangleMirrored,
			[ RoundedRectangle.NAME ]: RoundedRectangle,
			[ Egg.NAME ]: Egg,
			[ Ellipse.NAME ]: Ellipse,
			[ FlatOval.NAME ]: FlatOval,
			[ IsoscelesTriangle.NAME ]: IsoscelesTriangle,
			[ HalfCircle.NAME ]: HalfCircle,
			[ QuarterCircle.NAME ]: QuarterCircle,
			[ Hexagon.NAME ]: Hexagon,
			[ Octagon.NAME ]: Octagon,
			[ Polygon.NAME ]: Polygon,
			[ Arrow.NAME ]: Arrow,
			[ Star.NAME ]: Star,
			[ SlopedRectangle.NAME ]: SlopedRectangle,
			[ SlopedRectangleFlipHorizontal.NAME ]: SlopedRectangleFlipHorizontal,
			[ SlopedRightRectangle.NAME ]: SlopedRightRectangle,
			[ SlopedRightRectangleFlipVertical.NAME ]: SlopedRightRectangleFlipVertical,
			[ ArchedRectangle.NAME ]: ArchedRectangle,
			[ Heart.NAME ]: Heart,
			[ Text.NAME ]: Text,
			[ Trapezoid.NAME ]: Trapezoid,
			[ Kite.NAME ]: Kite,
			[ Barrel.NAME ]: Barrel,
			[ Jewel.NAME ]: Jewel,
			[ Droplet.NAME ]: Droplet,
			[ Parallelogram.NAME ]: Parallelogram,
			[ ParallelogramFlipHorizontal.NAME ]: ParallelogramFlipHorizontal,
		};
	}

	/**
	 * @param {string|number} shape_name
	 * @param {*} primitives
	 *
	 * @returns {AbstractShape|NullShape} The shape instance.
	 */
	create_shape_from_primitives( shape_name, primitives ) {
		if ( !( shape_name in this.shapes ) ) {
			return new NullShape();
		}

		return this.shapes[ shape_name ].deserialize_primitives( primitives );
	}

	/**
	 * @param {string|number} shape_name
	 * @returns {AbstractShape|NullShape} The shape instance.
	 */
	get_shape_object( shape_name ) {
		return this.shapes[ shape_name ] ?? new NullShape();
	}
}
